import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './users.routes';
import _ from 'lodash';

export class UsersController {
  order = {
    field: 'Operation.name',
    direction: false
  };

  /*@ngInject*/
  constructor($http, User, $uibModal, $rootScope, ngToast) {
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.$http = $http;
    this.User = User;
    this.ngToast = ngToast;

    this.refreshlist();
  }

  refreshlist() {
    this.users = this.User.query();
  }

  $onInit() {
  }

  sort(field) {
    if(this.order.field == field) {
      this.order.direction = !this.order.direction;
    } else {
      this.order.field = field;
      this.order.direction = false;
    }
  }

  addUser() {
    console.log('open modal...');
    let modal = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./addUser.html'),
      controller: 'AddUserController',
      controllerAs: '$ctrl',
      resolve: {
        user() {}
      }
    });

    modal.result.then(user => {
      if(user) {
        this.refreshlist();
      }
    });
  }

  editUser(user) {
    console.log('open modal...');
    let modal = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./addUser.html'),
      controller: 'AddUserController',
      controllerAs: '$ctrl',
      resolve: {
        user() {
          console.log('returning user on resolve:', user);
          return _.clone(user);
        }
      }
    });

    modal.result.then(updatedUser => {
      if(updatedUser) {
        this.refreshlist();
      }
    });
  }

  deleteUser(user) {
    console.log('launch Modal to confirm delete...');

    var modalScope = this.$rootScope.$new();
    angular.extend(modalScope, {user});

    modalScope.$uibModalInstance = this.$uibModal.open({
      animation: false,
      template: require('./deleteUser.html'),
      scope: modalScope,
    });

    modalScope.$uibModalInstance.result.then(() => {
      console.log('delete: ', user);
      user.$remove().then(
        () => {
          this.users.splice(this.users.indexOf(user), 1);
        },
        error => {
          this.ngToast.create({className: 'danger', content: `Error: An error occured: ${error.data.name}: ${error.data.message}`});
        }
      );
    });
  }

  changePassword(user) {
    var modalScope = this.$rootScope.$new();
    angular.extend(modalScope, {user});

    modalScope.$uibModalInstance = this.$uibModal.open({
      animation: false,
      template: require('./changePassword.html'),
      scope: modalScope
    });

    modalScope.$uibModalInstance.result.then(updated => {
      console.log('changePassword: ', updated);
      this.$http.put('/api/users/password', updated)
        .then(
          result => {
            this.ngToast.create({className: 'success', content: `The password for ${updated.name} has been updated.`});

            console.log('rsp:', result);
          },
          error => {
            this.ngToast.create({className: 'danger', content: `Error: An error occured: ${error.data.name}: ${error.data.message}`});
          }
        );
    });
  }
}

export default angular.module('hccApp.users', [uiRouter])
  .config(routing)
  .component('users', {
    template: require('./users.html'),
    controller: UsersController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/users/users.component.js